export enum TestadoPagoFotnur{
  SinEstado = 0,
  pago = 1,
  nopago = 2
}

export enum TestadoTextoPagoFontur {
  pagoManual = 'SI'
}
